import React from 'react';
import classnames from 'classnames';

interface Props {
  width?: string;
  height?: string;
  loading?: boolean;
  children?: React.ReactNode;
}

const EmptyModalContent: React.FC<Props> = ({
  width = '350px',
  height = '400px',
  loading = false,
  children = null,
}) => {
  const modalInlineStyle = {
    width,
    height,
  };
  const modalClass = classnames(
    'relative rounded-sm bg-white mx-auto z-40 max-w-[520px] h-full sm:h-auto sm:rounded-sm sm:max-w-none',
    { loading },
  );
  return (
    <div className={modalClass} style={modalInlineStyle}>
      <div className="mb-0 bg-white rounded-none">{children}</div>
    </div>
  );
};

export default EmptyModalContent;
